import { render } from "./ProfileStepFour.vue?vue&type=template&id=35d89e5d&scoped=true"
import script from "./ProfileStepFour.vue?vue&type=script&lang=js"
export * from "./ProfileStepFour.vue?vue&type=script&lang=js"

import "./ProfileStepFour.vue?vue&type=style&index=0&id=35d89e5d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d89e5d"]])

export default __exports__